<template>
  <v-app>
    <v-main>
      <v-app-bar color="white" elevate-on-scroll dense style="overflow: hidden">
        <template v-slot:img>
          <v-img src="./assets/bg.svg"></v-img>
        </template>
        <v-btn style="margin-left:40px;" icon absolute @click="goBack" v-if="currentPath.name !== 'Home'">
          <v-icon color="white">mdi-arrow-left</v-icon>
        </v-btn>
        <v-btn icon absolute @click="goBackHome" v-if="currentPath.name !== 'Home'">
          <v-icon color="white">mdi-home</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title class="white--text font-weight-bold headerTitle">{{
          currentPath.title
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Cookie from "js-cookie";
import jwt_decode from "jwt-decode";
import { mapActions, mapState } from "vuex";
import api from "./api/api";
export default {
  name: "App",
  data: () => ({
    path: [
      {
        name: "Home",
        title: "首页",
      },
      {
        name: "DistributorMgt",
        title: "客户管理",
        back: "/",
      },
      {
        name: "DistributorDetail",
        title: "客户信息",
        back: "/distributor",
      },
      {
        name: "DistributorList",
        title: "客户信息",
        back: "/distributor",
      },
      {
        name: "StoreMgt",
        title: "门店管理",
        back: "/",
      },
      {
        name: "StoreList",
        title: "门店管理",
        back: "/store",
      },
      {
        name: "StoreDetail",
        title: "门店信息",
        back: "/store",
      },
      {
        name: "TargetMgt",
        title: "目标管理",
        back: "/",
      },
      {
        name: "TargetAdmin",
        title: "目标管理",
        back: "/",
      },
      {
        name: "UserMgt",
        title: "用户管理",
        back: "/",
      },
      {
        name: "UserDetail",
        title: "用户信息",
        back: "/user",
      },
      {
        name: "VisitingMgt",
        title: "日常拜访",
        back: "/",
      },
      {
        name: "VisitingDetail",
        title: "拜访记录",
        back: "/visiting",
      },
      {
        name: "VisitingList",
        title: "拜访记录",
        back: "/",
      },
      {
        name: "VisitingListByDealer",
        title: "拜访记录",
        back: "-1",
      },
    ],
    num: 0,
  }),
  computed: {
    ...mapState(["back"]),
    currentPath() {
      return this.path.filter((item) => item.name === this.$route.name)[0];
    },
  },
  methods: {
    ...mapActions(["SET_USER", "SET_CATEGORY", "SET_BACK"]),
    goBackHome(){
      // this.$router.push({
      //     path: `/`,
      //   });
      window.location.href = process.env.VUE_APP_HOME_REC;
    },
    goBack() {
      const barArr = [...this.back];
      const target = barArr.pop();

      if (barArr.length == 0 || target?.path === "/") {
        window.location.href = process.env.VUE_APP_HOME_REC;
      } else if (target?.path === "/target") {
        target.query = this.$route.query;
        this.$router.push(target);
      } else if (
        target.path !== "/target" &&
        (this.$route.name == "DistributorList" ||
          this.$route.name == "StoreList" ||
          this.$route.name == "VisitingDetail")
      ) {
        target.query = this.$route.query;
        this.$router.push(target);
      } else {
        this.$router.push(target);
      }
      Cookie.set("back", JSON.stringify(barArr));
      this.SET_BACK(barArr);
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    getCategroy() {
      api.common.getAllCategory().then((res) => {
        const { data, status } = res.data;
        if (data && status == 200) {
          this.SET_CATEGORY(data.list);
        }
      });
    },
  },
  created() {
    const token = Cookie.get("adfs-token");
    const back = Cookie.get("back");
    if (back) {
      this.SET_BACK(JSON.parse(back));
    } else {
      this.SET_BACK([]);
    }
    if (token) {
      const decoded = jwt_decode(token);
      const { sub, authorities, userId, userRegionCode, userRegionName } =
        decoded;
      this.SET_USER({
        role: authorities,
        username: sub,
        token,
        userId,
        userRegionCode: userRegionCode,
        userRegionName,
      });
      this.getCategroy();
    }
    // alert(document.documentElement.clientHeight);
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = document.documentElement.clientHeight * 0.01;
    // let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    // We listen to the resize event
    window.addEventListener("resize", () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  },
  mounted() {},
};
</script>

<style lang="sass" scoped>
#app
  margin: 0
  width: 100%
  height: 100%
  main
    height: 100%
  .headerTitle
    letter-spacing: 5px
</style>
